export default {
    LOAD_PRODUCTPHOTOS (state, productphotos) {
        state.items = productphotos
    },
    LOAD_PHOTOS_BY_PRODUCT (state, productphotos) {
        state.fotos = productphotos
    }
}